import { Pipe, PipeTransform } from '@angular/core';
import { StringUtility } from '@app/shared/string-utility';

@Pipe({ name: 'getLocationName' })
export class GetLocationNamePipe implements PipeTransform {
  transform(data: any): any {
    return data ? StringUtility.getLocationName(data) : '';
  }
}
